module.exports = __webpack_public_path__ + "img/thumbnail_Wolverine_f_leucistic.a3734712.png";